import { useNodeInfo } from '../hooks/use_node_info';
import Homepage from './Home/Homepage';
import Layout from '../Routes/Layout';

// Node feature toggle (feature_gathering) — nodes without Gathering fall back
// to the Homepage/browse view if someone lands on /gathering directly (e.g. a
// shared link from a node that has it). GatheringPage itself renders with no
// Layout (full-screen, like Entity), so the fallback wraps its own Layout
// here to keep the NavBar/Footer chrome.
const GatheringGate = ({ children }) => {
    const { featureGathering } = useNodeInfo();
    return featureGathering ? children : <Layout><Homepage /></Layout>;
};

export default GatheringGate;
